<div
  class="box-bid"
  *ngIf="((!vehicle.bidValue && vehicle.expirationTimeLeft > 0) || !vehicle.expiration || forceNewOffer) && (!vehicle.sold || vehicle.boughtByMe)"
  (click)="$event.stopPropagation(); $event.preventDefault()"
>
  <div class="row">
    <div class="col-md-12">
      <div class="title-box">
        <i class="app-icon-tag" style="margin-right: 8px"></i>
        FAZER UMA OFERTA
      </div>
    </div>
    <div class="col-md-12 bid-error-message" *ngIf="bidErrorMessage">
      Houve um problema com a sua oferta:<br />
      {{ bidErrorMessage }}
      <ng-container *ngIf="showLatePaymentLink"
        ><a [routerLink]="['/arrematar/arrematados']" [queryParams]="latePaymentQueryParams">Veja aqui</a> seus veículos com fee plataforma
        pendente.</ng-container
      >
    </div>
    <div class="col-md-12 value">
      <mat-form-field>
        <span matPrefix class="currency-symbol">R$&nbsp;</span>
        <input
          matInput
          currencyMask
          [options]="{ prefix: '', thousands: '.', precision: 0, allowNegative: false }"
          type="tel"
          [(ngModel)]="bidValue"
          (click)="$event.stopPropagation(); $event.preventDefault()"
        />
        <mat-icon matSuffix style="font-size: 24px; color: #ffffff">mode_edit</mat-icon>
        <mat-hint class="stats" *ngIf="isLessThanMin() || isMoreThanMax() || rejectedBid">
          <div *ngIf="isMoreThanMax()" class="error">Sua oferta deve ser menor do que R$ 1.000.000</div>
          <div *ngIf="rejectedBid">Sua oferta anterior de R$ {{ rejectedBid | number }} foi rejeitada.</div>
          <div *ngIf="isLessThanMin()" class="error">Oferta mínima: R$ {{ vehicle.minBidValue | number }}</div>
        </mat-hint>
      </mat-form-field>
    </div>
    <div
      class="col-md-12 button-group"
      *ngIf="vehicle.bidStep && vehicle.highestBid"
    >
      <button
        class="btn btn-outline-white btn-rounded btn-bg"
        [style.backgroundColor]=""
        style="font-family: 'Raleway', sans-serif"
        (click)="addToBid(1); $event.stopPropagation(); $event.preventDefault()"
      >
        <i class="material-icons">add</i>{{ vehicle.bidStep | number }}
      </button>
      <button
        class="btn btn-outline-white btn-rounded ml-2 btn-bg"
        style="font-family: 'Raleway', sans-serif"
        (click)="addToBid(2); $event.stopPropagation(); $event.preventDefault()"
      >
        <i class="material-icons">add</i>{{ vehicle.bidStep * 2 | number }}
      </button>
      <button
        class="btn btn-outline-white btn-rounded ml-2 btn-bg"
        style="font-family: 'Raleway', sans-serif"
        (click)="addToBid(3); $event.stopPropagation(); $event.preventDefault()"
      >
        <i class="material-icons">add</i>{{ vehicle.bidStep * 3 | number }}
      </button>
    </div>

    <div class="col-md-12">
      <div class="description" *ngIf="disableConfirmationModal && !fromCard && calculateCommissionValue() > 0">
        <div class="value-info">
          <div class="row">
            <span>Valor da oferta:</span>
            <span>R$ {{ bidValue | number:'1.2-2' }}</span>
          </div>
          <div class="row">
            <span>Fee plataforma:</span>
            <span>R$ {{ calculateCommissionValue() | number:'1.2-2' }}</span>
          </div>
        </div>
        <div class="total-estimate">
          <strong>Total estimado da operação:</strong>
          <span class="estimated-value">R$ {{ calculateTotalOperation() | number:'1.2-2' }}</span>
          <small class="observation">O valor da fee plataforma é uma estimativa e só será cobrado se o veículo for adquirido.</small>
        </div>
      </div>

      <button
        class="btn btn-primary btn-rounded btn-block btn-lg mt-2"
        (click)="disableConfirmationModal ? makeABid() : openModal(); $event.stopPropagation(); $event.preventDefault()"
        [disabled]="isLessThanMin() || isMoreThanMax() || !bidValue"
      >
        FAÇA SUA OFERTA
      </button>
    </div>

    <div class="col-md-12 text-center stats" *ngIf="vehicle.views">
      <i class="material-icons">remove_red_eye</i>
      {{ vehicle.views | number }}
      {{ vehicle.views > 1 ? "pessoas já viram" : "pessoa já viu" }}
      esse veículo
    </div>

    <div class="col-md-12 text-center stats" *ngIf="vehicle.highestBid">
      <i class="app-icon-tag" style="margin-right: 4px"></i>
      <span>Maior oferta atual de:&nbsp;</span>R$ {{ vehicle.highestBid | number }}
    </div>
  </div>
</div>

<div class="row mb-4" *ngIf="pendingCounterOffer?.status === 'WAITING'">
  <div class="col-12 mb-4">
    <div class="box-contra-proposta">
      <div class="title-box">Contra proposta recebida</div>
      <div class="value">
        <span class="currency-symbol">R$ </span>
        {{ pendingCounterOffer.value | number }}
      </div>
      <div class="message" *ngIf="pendingCounterOffer.message">
        {{ pendingCounterOffer.message }}
      </div>
      <div class="disclaimer">
        Ao aceitar esta contra proposta, você estará automaticamente se comprometendo a efetuar a compra deste veículo ao valor de R$
        {{ pendingCounterOffer.value | number }}. Sua oferta original era de R$ {{ vehicle.bidValue | number }}.
      </div>

      <div class="col-md-12 warning-box" *ngIf="counterOfferErrorMessage">
        <i class="material-icons">warning</i>
        {{ counterOfferErrorMessage }}
      </div>

      <button class="btn btn-primary btn-rounded btn-lg btn-block text-white" (click)="acceptCounterOffer(); $event.stopPropagation()">
        ACEITAR CONTRA PROPOSTA
      </button>
      <button class="btn btn-danger btn-rounded btn-block" (click)="rejectCounterOffer(); $event.stopPropagation()">REJEITAR</button>
    </div>
  </div>
</div>

<div
  class="box-owns-current-bid"
  *ngIf="vehicle.bidValue && !forceNewOffer && (!vehicle.sold || vehicle.boughtByMe)"
  (click)="$event.stopPropagation(); $event.preventDefault()"
>
  <ng-container *ngIf="(vehicle.expirationTimeLeft > 0 || !vehicle.expiration) && (!vehicle.sold || vehicle.boughtByMe)">
    <div class="contents-box">
      <ng-container *ngIf="vehicle.highestBid && vehicle.highestBid > vehicle.bidValue">
        <div class="title-box-highestBid">
          <i class="app-icon-tag" style="margin-right: 8px; font-size: 20px"></i>
          Maior oferta atual
        </div>
        <div class="value-highestBid">R$ {{ vehicle.highestBid | number }}</div>
      </ng-container>
      <div class="title-box-myOffer">Sua oferta</div>
      <div class="value-myOffer">R$ {{ vehicle.bidValue | number }}</div>
    </div>
    <div class="cancel-bid text-center mt-3" *ngIf="!vehicle.sold">
      <button (click)="clickToMakeNewOffer(); $event.stopPropagation(); $event.preventDefault()" class="btn btn-outline-white-new" style="width: 100%">
        FAZER UMA NOVA PROPOSTA
      </button>
      <div class="mt-2 cursor-pointer" (click)="cancelBid(); $event.stopPropagation(); $event.preventDefault()">CANCELAR OFERTA</div>
    </div>
    <div class="col-md-12 text-center stats" *ngIf="vehicle.views">
      <i class="material-icons">remove_red_eye</i>{{ vehicle.views | number }}
      <span *ngIf="vehicle.views > 1">&nbsp;pessoas já viram&nbsp;</span>
      <span *ngIf="vehicle.views <= 1">&nbsp;pessoa já viu&nbsp;</span>
      esse veículo
    </div>
  </ng-container>
  <ng-container *ngIf="vehicle.expirationTimeLeft <= 0">
    <div class="contents-box">
      <div class="title-box">
        <i class="app-icon-tag" style="margin-right: 8px"></i>
        Sua oferta
      </div>
      <div class="value">R$ {{ vehicle.bidValue | number }}</div>
      <div class="fast-quote-finished">
        <i class="app-icon-timer"></i>
        <p>Cotação finalizada.</p>
      </div>
    </div>
    <div class="col-md-12 text-center stats" *ngIf="vehicle.views">
      <i class="material-icons">remove_red_eye</i>{{ vehicle.views | number }}
      <span *ngIf="vehicle.views > 1">&nbsp;pessoas já viram&nbsp;</span>
      <span *ngIf="vehicle.views <= 1">&nbsp;pessoa já viu&nbsp;</span>
      esse veículo
    </div>
  </ng-container>
</div>

<div class="modal-backdrop fade in" [style.display]="showModal ? 'block' : 'none'"></div>
<div class="modal fade" [ngClass]="{ show: showModal, hide: !showModal }" [style.display]="showModal ? 'block' : 'none'" (click)="closeModal()">
  <div class="modal-dialog modal-dialog-centered" (click)="(false); $event.stopPropagation()">
    <div class="modal-content box-modal-bid">
      <ng-container *ngIf="canBid()">
        <div class="modal-header">
          <h5 class="title-box">
            <i class="app-icon-tag" style="margin-right: 8px"></i>
            Confirmar oferta
          </h5>
          <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">
            <i class="material-icons">close</i>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12 warning-box final-bid-error" *ngIf="bidErrorMessage">
            <div class="d-flex"><i class="material-icons">warning</i><strong>Houve um problema com a sua oferta</strong></div>
            <div>
              {{ bidErrorMessage }}
              <ng-container *ngIf="showLatePaymentLink"
                ><a [routerLink]="['/arrematar/arrematados']" [queryParams]="latePaymentQueryParams">Veja aqui</a> seus veículos com fee plataforma
                pendente.</ng-container
              >
            </div>
          </div>

          <div class="main-value" *ngIf="!bidErrorMessage">
            R$ {{ bidValue | number }}
          </div>

          <div class="value-info" *ngIf="!bidErrorMessage && calculateCommissionValue() > 0">
            <div class="row">
              <span>Valor da oferta:</span>
              <span>R$ {{ bidValue | number:'1.2-2' }}</span>
            </div>
            <div class="row">
              <span>Fee plataforma:</span>
              <span>R$ {{ calculateCommissionValue() | number:'1.2-2' }}</span>
            </div>
          </div>

          <div class="total-estimate" *ngIf="!bidErrorMessage && calculateCommissionValue() > 0">
            <strong>Total estimado da operação:</strong>
            <span class="estimated-value">R$ {{ calculateTotalOperation() | number:'1.2-2' }}</span>
            <small class="observation">O valor da fee plataforma é uma estimativa e só será cobrado se o veículo for adquirido.</small>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary btn-rounded btn-lg btn-block" (click)="makeABid()" *ngIf="!bidErrorMessage">CONFIRMAR OFERTA</button>

          <button class="btn btn-primary btn-rounded btn-lg btn-block" (click)="confirmErrorBid()" *ngIf="bidErrorMessage">ENTENDI</button>
        </div>
      </ng-container>
      <ng-container *ngIf="!canBid()">
        <app-access-account-modal-body (closeModal)="closeModal()"></app-access-account-modal-body>
      </ng-container>
    </div>
  </div>
</div>
